var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-tabs",
    {
      attrs: { type: "card" },
      model: {
        value: _vm.activeName,
        callback: function ($$v) {
          _vm.activeName = $$v
        },
        expression: "activeName",
      },
    },
    _vm._l(_vm.data, function (item) {
      return _c(
        "el-tab-pane",
        { key: item.k, attrs: { label: item.k, lazy: true, name: item.k } },
        [_c("Java", { attrs: { value: item.v, height: "600px" } })],
        1
      )
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }